import React from 'react'
import { TextWrapper } from './TextStyles'

export default function TextContainer({ children: content, fadeIn }: any) {
  return (
    <div style={{ height: '15px' }}>
      <TextWrapper fadeIn={fadeIn}>{content}</TextWrapper>
    </div>
  )
}
